const norm = (s) => (s || "").trim().toLowerCase();

export const assignBookings = (bookings, vehicles) => {
  const byVehicle = {};
  vehicles.forEach((v) => { byVehicle[v.id] = []; });
  const unmatched = [];
  for (const b of bookings) {
    let target = vehicles.find((v) => v.rego && b.vehicle_rego && norm(v.rego) === norm(b.vehicle_rego));
    if (!target) {
      target = vehicles.find((v) =>
        norm(b.vehicle_make) === norm(v.make) &&
        norm(b.vehicle_model) === norm(v.model) &&
        String(b.vehicle_year) === String(v.year)
      );
    }
    if (target) byVehicle[target.id].push(b);
    else unmatched.push(b);
  }
  return { byVehicle, unmatched };
};
